/**
 * @desc 删除预告公告
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DeleteAnnouncementParameter = {
  ids?: Array<string>
}

const method = 'DELETE'
const url = '/trade/operation/announcement'

export const deleteAnnouncementApi = (
  params?: DeleteAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

deleteAnnouncementApi.method = method
deleteAnnouncementApi.url = url
